<template>
  <div class="content">
    <v-card>
      <v-tabs v-model="currentTabIndex" background-color="#e2007a" dark>
        <v-tab v-for="tab in tabs" :key="tab" :value="tab">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <div v-if="currentTabIndex == 1">
      <md-card class="p-4">
        <div class="font-medium text-xl pb-4">Cabinet</div>
        <div class="font-medium pt-2">LICENCE MS4</div>
        <md-card>
          <div class="md-layout margeTopSearchBar">
            <div class="md-layout-item md-size-50" style="position: relative">
              <md-field style="margin-top: -10px">
                <label>Numéro de licence</label>
                <md-input
                  v-on:keyup.enter="searchLicences"
                  v-model="licenceNuquery"
                ></md-input>
              </md-field>
              <button class="diagCloseButton" @click="clearLicenceNumberSearch()">
                <md-icon>delete</md-icon>
              </button>
            </div>
            <div class="md-layout-item md-size-50" style="position: relative">
              <md-field style="margin-top: -10px">
                <label>Expert ou client</label>
                <md-input
                  v-on:keyup.enter="searchLicences"
                  v-model="licenceRequery"
                ></md-input>
              </md-field>
              <button class="diagCloseButton" @click="clearExpertSearch()">
                <md-icon>delete</md-icon>
              </button>
            </div>
          </div>
          <md-button class="md-prokov researcheButton" @click="searchLicences()">
            Rechercher
          </md-button>
        </md-card>

        <md-card v-if="licenceSearchPerformed" class="mt-4">
          <div class="md-subheading titleTables">
            Licences trouvées
            <span v-if="licenceSearchCountMessage" class="md-caption" style="margin-left: 10px">
              {{ licenceSearchCountMessage }}
            </span>
          </div>
          <md-divider></md-divider>
          <md-card-content>
            <div
              v-if="licenceSearchResults.length > 0"
              class="licence-search-results-scroll"
            >
              <md-table
                v-model="licenceSearchResults"
                table-header-color="prokov"
                @md-selected="onLicenceSelect"
              >
                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                  md-selectable="single"
                >
                  <md-table-cell md-label="Numéro de licence">
                    {{ item.licenceID }}
                    <span v-if="isLicenceDemoRow(item)" class="demo-licence-badge">
                      licence démo
                    </span>
                  </md-table-cell>
                  <md-table-cell md-label="Client">
                    {{ formatLicenceChoiceLabel(item) }}
                  </md-table-cell>
                  <md-table-cell md-label="Expert">{{
                    item.expert || "—"
                  }}</md-table-cell>
                  <md-table-cell md-label="Capacité">{{ item.capacite }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>
            <div v-else style="text-align: center">
              La recherche ne trouve aucune licence.
            </div>
          </md-card-content>
        </md-card>

        <md-card v-if="selectedLicence" class="mt-4 p-4">
          <div class="font-medium text-xl pb-4">
            Licence sélectionnée
            <span v-if="isLicenceDemoRow(selectedLicence)" class="demo-licence-badge">
              licence démo
            </span>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <md-field>
              <label>Numéro de licence</label>
              <md-input :value="selectedLicenceInfo.licenceNumber" disabled></md-input>
            </md-field>
            <md-field>
              <label>Revendeur</label>
              <md-input :value="selectedLicenceInfo.revendeur" disabled></md-input>
            </md-field>
            <md-field>
              <label>Expert</label>
              <md-input :value="selectedLicenceInfo.expert" disabled></md-input>
            </md-field>
            <md-field>
              <label>Client</label>
              <md-input :value="selectedLicenceInfo.client" disabled></md-input>
            </md-field>
          </div>
          <p
            v-if="selectedLicence.type !== 'M'"
            class="text-red-600 text-sm mt-2"
          >
            Seules les licences MédiStory 4 peuvent être activées pour DoctoDispo.
          </p>
        </md-card>
         <div class="font-medium pt-4">STRUCTURE</div>
         <div class="flex flex-col">
           <div class="flex flex-row gap-8">
             <md-field class="basis-1/4">
               <label>Identifiant de structure</label>
               <md-input 
                 required 
                 v-model="structure.finessNumber"
                 :disabled="structure.isDemoMode"
               ></md-input>
             </md-field>
             <md-field class="basis-1/4">
               <label>Nom public</label>
               <md-input v-model="structure.publicName"></md-input>
             </md-field>
             <md-field class="basis-1/4">
               <label>Nom légal</label>
               <md-input v-model="structure.legalName"></md-input>
             </md-field>
            </div>
          <div class="flex flex-row gap-8">
            <md-field class="basis-1/4">
              <label>Ville</label>
              <md-input v-model="structure.city"></md-input>
            </md-field>
            <md-field class="basis-1/4">
              <label>Code postal</label>
              <md-input v-model="structure.zipCode"></md-input>
            </md-field>
            <md-field class="basis-1/2">
              <label>Adresse</label>
              <md-input v-model="structure.address"></md-input>
            </md-field>
          </div>
        </div>
        <div class="flex flex-row gap-8">
          <md-field>
            <label>Email</label>
            <md-input v-model="structure.email"></md-input>
          </md-field>
          <md-field>
            <label>Numéro de téléphone</label>
            <md-input v-model="structure.phoneNumber"></md-input>
          </md-field>
        </div>

        <div class="font-medium text-xl pb-4">Contractant</div>

        <div class="flex flex-col">
          <div class="flex flex-row gap-8">
            <md-field>
              <label>Email</label>
              <md-input required v-model="contractor.email"></md-input>
            </md-field>
            <md-field>
              <label>Nom</label>
              <md-input required v-model="contractor.lastName"></md-input>
            </md-field>
            <md-field>
              <label>Prénom</label>
              <md-input required v-model="contractor.firstName"></md-input>
            </md-field>
          </div>
          <div class="flex flex-row gap-8">
            <md-field>
              <label>RPPS</label>
              <md-input v-model="contractor.rpps"></md-input>
            </md-field>
            <md-field>
              <label>Spécialité médicale</label>
              <md-input v-model="contractor.medicalSpeciality"></md-input>
            </md-field>
            <md-field>
              <label>Numéro de téléphone</label>
              <md-input required v-model="contractor.phoneNumber"></md-input>
            </md-field>
          </div>

          <div class="font-medium text-xl pb-4">Abonnement</div>
          <div class="flex flex-col">
            <div class="flex flex-row gap-8">
              <md-field>
                <label>Quantité agendas</label>
                <md-input required v-model="quantity"></md-input>
              </md-field>
              <md-datepicker v-model="activationDate">
                <label>Date d'activation</label>
              </md-datepicker>
              <md-datepicker required v-model="expirationDate">
                <label>Date d'expiration</label>
              </md-datepicker>
            </div>
            <div class="flex flex-row gap-8">
              <md-checkbox v-model="teleconsultationEnabled"
                >Activer la téléconsultation</md-checkbox
              >
            <div class="flex flex-col gap-2" v-if="teleconsultationEnabled">
              <md-field>
                <label>SIREN (9 chiffres)</label>
                <md-input required v-model="siren" maxlength="9"></md-input>
              </md-field>
              <div class="flex flex-row gap-6 items-center">
                <span class="font-medium">Prestataire de paiement *</span>
                <md-radio v-model="paymentProvider" :value="'PAYPLUG'">PAYPLUG</md-radio>
                <md-radio v-model="paymentProvider" :value="'DISPAY'">DISPAY</md-radio>
              </div>
            </div>
          </div>
          <div class="flex flex-col items-center">
            <md-button
              :disabled="
                structure?.finessNumber == null ||
                contractor?.email == null ||
                contractor?.lastName == null ||
                contractor?.firstName == null ||
                contractor?.phoneNumber == null ||
                Number(quantity) == 0 ||
                activationDate == null ||
                expirationDate == null ||
                selectedLicence == null ||
                selectedLicence.type !== 'M' ||
                (teleconsultationEnabled && !isTeleconsultationFormValid)
              "
              class="md-prokov"
              @click="submit()"
              >Valider {{ activationStatus }}</md-button
            >
          </div>
        </div>
        </div>
      </md-card>
    </div>
    <div v-if="currentTabIndex == 0">
      <md-card class="px-4">
        <md-table
          v-model="agendas"
          md-sort="activationDate"
          md-sort-order="asc"
          md-card
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell
              md-label="Licence MS4 associée"
              md-sort-by="ms4LicenceId"
            >
              {{ item?.ms4LicenceId }}
            </md-table-cell>
            <md-table-cell md-label="Structure ID" md-sort-by="structureId">
              {{ item?.structureId }}
            </md-table-cell>
            <md-table-cell
              md-label="Email contractant"
              md-sort-by="contractorEmail"
            >
              {{ item?.contractorEmail }}
            </md-table-cell>
            <md-table-cell md-label="Quantité" md-sort-by="quantity">
              <md-field v-if="item?.licenceId == editedAgenda?.licenceId">
                <label>Quantité agendas</label>
                <md-input v-model="editedAgenda.quantity"></md-input>
              </md-field>
              <div v-else>
                {{ item?.quantity }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Téléconsultation">
              <div v-if="item?.licenceId == editedAgenda?.licenceId" class="flex flex-row gap-2 items-center">
                <md-checkbox
                  v-model="editedAgenda.options.teleconsultation"
                ></md-checkbox>
              </div>
              <div v-else>
                {{ item?.options?.teleconsultation ? "Oui" : "Non" }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="SIREN" md-sort-by="siren">
              <div v-if="item?.licenceId == editedAgenda?.licenceId" class="flex flex-row gap-2 items-center">
                <md-input
                  v-if="editedAgenda.options.teleconsultation"
                  v-model="editedAgenda.options.siren"
                  maxlength="9"
                  placeholder="SIREN"
                  class="siren-edit-input"
                ></md-input>
                <span v-else class="text-gray-400">—</span>
              </div>
              <div v-else>
                {{ maskSiren(item?.options?.siren) }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Prestataire">
              <div v-if="item?.licenceId == editedAgenda?.licenceId" class="flex flex-row gap-2 items-center">
                <template v-if="editedAgenda.options.teleconsultation">
                  <md-radio v-model="editPaymentProvider" :value="'PAYPLUG'">PAYPLUG</md-radio>
                  <md-radio v-model="editPaymentProvider" :value="'DISPAY'">DISPAY</md-radio>
                </template>
                <span v-else class="text-gray-400">—</span>
              </div>
              <div v-else>
                {{ item?.options?.provider || "—" }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Activation" md-sort-by="activationDate">
              {{ new Date(item?.activationDate).toLocaleDateString("fr") }}
            </md-table-cell>
            <md-table-cell md-label="Expiration" md-sort-by="expirationDate">
              <md-datepicker
                v-if="item?.licenceId == editedAgenda?.licenceId"
                v-model="editedAgenda.expirationDate"
              >
                <label>Date d'expiration</label>
              </md-datepicker>
              <div v-else>
                {{
                  item.expirationDate
                    ? new Date(item?.expirationDate).toLocaleDateString("fr")
                    : "Abonné"
                }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Renouvellement auto">
              <md-checkbox
                v-model="item.autoRenewalDoctoDispo"
                @change="toggleAutoRenewal(item)"
                :disabled="updatingLicence === item.licenceId"
              ></md-checkbox>
            </md-table-cell>
            <md-table-cell>
              <div class="flex flex-row gap-6 h-12">
                <div
                  class="flex flex-row gap-4"
                  v-if="item?.licenceId == editedAgenda?.licenceId"
                >
                  <md-button
                    style="width: 10px !important"
                    @click="onEditCancel()"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                  <md-button
                    style="width: 10px !important"
                    @click="onEditValidate()"
                  >
                    <md-icon>check</md-icon>
                  </md-button>
                </div>
                <md-button
                  v-else
                  style="width: 20px !important"
                  @click="edit(item)"
                >
                  <md-icon>create</md-icon>
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card>
    </div>
  </div>
</template>

<script>
import { useStructureIdentifier } from "../composables/useStructureIdentifier";
import toolsFormat from "@/tools/toolsFormat.js";

export default {
  name: "Agenda",
  data() {
    return {
      currentTabIndex: 0,
      tabs: ["UTILISATEURS", "ACTIVATION"],
      licenceNuquery: "",
      licenceRequery: "",
      licenceSearchPerformed: false,
      selectedLicence: null,
      structureType: "PS",
      structure: {
        finessNumber: null,
        publicName: "",
        legalName: "",
        address: "",
        zipCode: "",
        city: "",
        email: null,
        phoneNumber: "",
        typeOptions: ["PS", "SCM", "SCP", "SISA", "MSP", "CDS"],
        type: "PS",
        isDemoMode: false,
      },
      contractor: {
        lastName: null,
        firstName: null,
        rpps: null,
        medicalSpeciality: "",
        email: null,
        phoneNumber: null,
        imatAM: 0,
      },
      quantity: 0,
      activationDate: new Date(),
      expirationDate: (() => {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 1);
        return date;
      })(),
      teleconsultationEnabled: false,
      siren: null,
      paymentProvider: null,
      editedAgenda: null,
      editPaymentProvider: null,
      editedExpirationDate: null,
       editedQuantity: null,
       updatingLicence: null,
     };
   },
   mounted() {
     this.$store.dispatch('agenda/getExperts');
     this.$store.dispatch('agenda/getAgendas');
   },
   setup() {
     const {
       handleLicenceChange,
       isLicenceDemo,
       normalizeLicenceId,
     } = useStructureIdentifier();
     return {
       handleLicenceChange,
       isLicenceDemo,
       normalizeLicenceId,
     };
   },
   computed: {
    activationStatus: {
      get() {
        return this.$store.getters["agenda/getStatus"];
      },
      set(newValue) {},
    },
    experts: {
      get() {
        return this.$store.getters["agenda/getExperts"];
      },
      set(newValue) {},
    },
    licenceSearchResults: {
      get() {
        const res = this.$store.getters["agenda/getMs4LicenceSearch"];
        if (res?.data?.licences?.rows) {
          return res.data.licences.rows;
        }
        return [];
      },
      set() {},
    },
    licenceSearchCountMessage() {
      const res = this.$store.getters["agenda/getMs4LicenceSearch"];
      if (!res?.data?.licences) {
        return "";
      }
      const { count, rows } = res.data.licences;
      if (count <= rows.length) {
        return `${rows.length} licence(s) affichée(s).`;
      }
      return `${rows.length} licence(s) affichée(s) sur ${count} — affinez la recherche si besoin.`;
    },
    selectedLicenceInfo() {
      if (!this.selectedLicence) {
        return {
          licenceNumber: "",
          revendeur: "",
          expert: "",
          client: "",
        };
      }
      const parsed = this.parseLicenceCustomer(this.selectedLicence.customer);
      const expert = this.selectedLicence.expert || parsed.expert;
      const client = this.selectedLicence.cabinet || parsed.client;
      const revendeur =
        this.selectedLicence.revendeur ||
        this.experts.find(
          (company) =>
            Number(company.companyID) ===
            Number(this.selectedLicence.companyID)
        )?.name ||
        expert;
      return {
        licenceNumber: this.selectedLicence.licenceID,
        revendeur,
        expert,
        client,
      };
    },
    agendas: {
      get() {
        let list = this.$store.getters["agenda/getAgendas"];
        return list;
      },
      set(newValue) {},
    },
    isSirenValid: {
      get() {
        return this.siren == null || this.siren.length === 9;
      },
      set() {},
    },
    isTeleconsultationFormValid: {
      get() {
        if (!this.teleconsultationEnabled) {
          return true;
        }
        return (
          typeof this.siren === "string" &&
          this.siren.length === 9 &&
          this.isPaymentProviderValid(this.paymentProvider)
        );
      },
      set() {},
    },
  },
  watch: {
    agendas: function (newVal, oldVal) {},
    currentTabIndex: function (newVal, oldVal) {
      this.$store.dispatch("agenda/getAgendas");
    },
    teleconsultationEnabled: function (enabled) {
      if (!enabled) {
        this.siren = null;
        this.paymentProvider = null;
      }
    },
    "editedAgenda.options.teleconsultation": function (enabled) {
      if (!enabled) {
        this.editPaymentProvider = null;
      }
    },
  },
  methods: {
    parseLicenceCustomer(customer) {
      if (!customer || typeof customer !== "string") {
        return { expert: "—", client: "—" };
      }
      const parts = customer.split(" - ");
      if (parts.length >= 2) {
        return {
          expert: parts[0].trim(),
          client: parts.slice(1).join(" - ").trim(),
        };
      }
      return { expert: "—", client: customer.trim() };
    },
    formatLicenceChoiceLabel(item) {
      const cabinet = item.cabinet || this.parseLicenceCustomer(item.customer).client;
      if (!cabinet || cabinet === "—") {
        return item.licenceID;
      }
      return `${cabinet} (licence : ${Number(item.licenceID)})`;
    },
    getLicenceSoftwareType(type) {
      const dict = {
        M: "MédiStory 4",
        E: "ExpressVitale",
        P: "VigiPaiement",
        C: "VigiCompta",
      };
      return dict[type] || type || "";
    },
    formatLicenceDate(date) {
      if (!date) {
        return "";
      }
      return toolsFormat.getDateLong(date);
    },
    async searchLicences() {
      const hasLicenceNumber = this.licenceNuquery.trim().length > 0;
      const hasCustomer = this.licenceRequery.trim().length > 0;
      if (!hasLicenceNumber && !hasCustomer) {
        this.showNotification(
          "error",
          "Veuillez renseigner au moins un critère de recherche"
        );
        return;
      }
      this.licenceSearchPerformed = true;
      this.selectedLicence = null;
      try {
        await this.$store.dispatch("agenda/searchMs4Licences", {
          n: hasLicenceNumber ? this.licenceNuquery.trim() : undefined,
          r: hasCustomer ? this.licenceRequery.trim() : undefined,
          limit: 300,
        });
      } catch (errorInfo) {
        this.showErrorNotification(errorInfo);
      }
    },
    defaultExpirationDate() {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      return date;
    },
    clearLicenceNumberSearch() {
      this.licenceNuquery = "";
    },
    clearExpertSearch() {
      this.licenceRequery = "";
    },
    isLicenceDemoRow(licence) {
      return this.isLicenceDemo({
        licenceID: this.normalizeLicenceId(licence?.licenceID),
        demo: licence?.demo,
        licences: [
          {
            licenceID: this.normalizeLicenceId(licence?.licenceID),
            demo: licence?.demo,
          },
        ],
      });
    },
    onLicenceSelect(licence) {
      if (!licence) {
        this.selectedLicence = null;
        return;
      }
      this.selectedLicence = licence;
      const licenceId = this.normalizeLicenceId(licence.licenceID);
      const updates = this.handleLicenceChange(
        {
          licenceID: licenceId,
          ms4LicenceId: licenceId,
          demo: licence.demo,
          licences: [{ licenceID: licenceId, demo: licence.demo }],
        },
        this.structure
      );
      this.structure = { ...this.structure, ...updates };
    },
    isPaymentProviderValid(provider) {
      return provider === "PAYPLUG" || provider === "DISPAY";
    },
    edit(value) {
      value.expirationDate = new Date(value.expirationDate);
      const rawOptions = value.options;
      const options =
        typeof rawOptions === "string"
          ? JSON.parse(rawOptions)
          : { ...(rawOptions || {}) };

      this.editedAgenda = { ...value, options: {} };
      this.$set(this.editedAgenda, "options", options);

      if (this.editedAgenda.options.teleconsultation && !this.editedAgenda.options.siren) {
        this.$set(this.editedAgenda.options, "siren", "");
      }

      this.editPaymentProvider = this.isPaymentProviderValid(options.provider)
        ? options.provider
        : null;
    },
    onEditCancel() {
      this.editedAgenda = null;
      this.editPaymentProvider = null;
    },
    async onEditValidate() {
      // Validate SIREN when téléconsultation is enabled
      if (this.editedAgenda.options.teleconsultation) {
        const siren = this.editedAgenda.options.siren;
        if (!siren || siren.length !== 9) {
          this.showNotification("error", "Le SIREN est obligatoire (9 chiffres) lorsque la téléconsultation est activée");
          return;
        }
        if (!this.isPaymentProviderValid(this.editPaymentProvider)) {
          this.showNotification("error", "Le prestataire de paiement (PAYPLUG ou DISPAY) est obligatoire lorsque la téléconsultation est activée");
          return;
        }
      }
      
      const param = {
        licenceId: this.editedAgenda.licenceId,
        quantity: this.editedAgenda.quantity,
        expirationDate: this.editedAgenda.expirationDate,
        options: {
          teleconsultation: this.editedAgenda.options.teleconsultation,
        },
      };
      
      if (this.editedAgenda.options.teleconsultation) {
        param.options.siren = this.editedAgenda.options.siren;
        param.options.provider = this.editPaymentProvider;
      }
      
      try {
        await this.$store.dispatch("agenda/updateAgenda", param);
        this.editedAgenda = null;
        this.showNotification("success", "Licence mise à jour avec succès");
      } catch (errorInfo) {
        this.showErrorNotification(errorInfo);
      }
    },
    async submit() {
      const options = this.teleconsultationEnabled
        ? {
            teleconsultation: true,
            siren: this.siren,
            provider: this.paymentProvider,
          }
        : {}
      const param = {
        activationDate: this.activationDate,
        expirationDate: this.expirationDate,
        ms4LicenceId: String(Number(this.selectedLicence.licenceID)).padStart(
          6,
          "0"
        ),
        structure: this.structure,
        contractor: this.contractor,
        quantity: this.quantity,
        options,
        teleconsultationEnabled: this.teleconsultationEnabled,
      };
      
      try {
        await this.$store.dispatch("agenda/activateAgenda", param);
        this.selectedLicence = null;
        this.licenceSearchPerformed = false;
        this.licenceNuquery = "";
        this.licenceRequery = "";
        this.expirationDate = this.defaultExpirationDate();
        this.siren = null;
        this.paymentProvider = null;
        this.showNotification("success", "Licence DoctoDispo activée avec succès");
      } catch (errorInfo) {
        this.showErrorNotification(errorInfo);
      }
    },
    showNotification(type, message) {
      this.$notify({
        message: message,
        icon: type === "success" ? "check_circle" : "error",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: type,
        timeout: 5000,
      });
    },
    /**
     * Masque un SIREN pour affichage (RGPD) : conserve uniquement les 3 derniers chiffres
     * @param {string|null|undefined} siren
     * @returns {string} "***789" ou "" si pas de siren
     */
    maskSiren(siren) {
      if (!siren || typeof siren !== "string" || siren.length < 3) {
        return "";
      }
      return `***${siren.slice(-3)}`;
    },
    showErrorNotification(errorInfo) {
      const errorTypeLabels = {
        EQWO_API_ERROR: "Erreur EQWO",
        LICENCE_NOT_FOUND: "Licence introuvable",
        VALIDATION_ERROR: "Erreur de validation",
        MISSING_API_KEY: "Configuration serveur",
        NETWORK_ERROR: "Erreur réseau",
        AUTHENTICATION_ERROR: "Erreur d'authentification",
        INTERNAL_ERROR: "Erreur interne",
        UNKNOWN_ERROR: "Erreur",
      };
      
      const typeLabel = errorTypeLabels[errorInfo.type] || errorInfo.type;
      const message = `${typeLabel}: ${errorInfo.message}`;
      
      this.$notify({
        message: message,
        icon: "error",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger",
        timeout: 7000,
      });
    },
    async toggleAutoRenewal(item) {
      try {
        this.updatingLicence = item.licenceId;
        await this.$store.dispatch("agenda/toggleDoctoDispoAutoRenewal", {
          licenceId: item.licenceId,
          autoRenewalDoctoDispo: item.autoRenewalDoctoDispo,
        });
      } catch (error) {
        // Revert the checkbox on error
        item.autoRenewalDoctoDispo = !item.autoRenewalDoctoDispo;
        throw new Error(
          "Erreur lors de la mise à jour du renouvellement automatique:",
          error
        );
      } finally {
        this.updatingLicence = null;
      }
    },
  },
};
</script>

<style lang="scss">
.titleTables {
  margin-top: 16px !important;
  margin-left: 20px !important;
  margin-bottom: 10px !important;
}

.licence-search-results-scroll {
  max-height: 320px;
  overflow-y: auto;
}

.diagCloseButton {
  position: absolute !important;
  top: 5px;
  right: 5px;
  border-style: none;
  background-color: white;
  border-color: white;
  cursor: pointer;
}

.demo-licence-badge {
  font-size: 0.7em;
  color: #2e7d32;
  margin-left: 6px;
}
</style>
